// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Primary Color */

/* Secondary Color */

/* Feedback Color */

/* GreyScale */

/* Contrast extended Color */

/** NEW COLOR VERSION **/

/* Primary Color */

/* Accent Color */

/* Neutral color */

/* Feedback color */

/* Typography */

/* Border */

/* Forms */

/* Button */
`, "",{"version":3,"sources":["webpack://./src/components/library/style/colors.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAIlB,oBAAoB;;AAIpB,mBAAmB;;AAInB,cAAc;;AAOd,4BAA4B;;AAc5B,wBAAwB;;AAExB,kBAAkB;;AAMlB,iBAAiB;;AAMjB,kBAAkB;;AAMlB,mBAAmB;;AAWnB,eAAe;;AAMf,WAAW;;AAGX,UAAU;;AAMV,WAAW","sourcesContent":["/* Primary Color */\n@value base-red: #F24C27;\n@value base-purple: #526AF2;\n\n/* Secondary Color */\n@value base-mint-green: #ACE2D0;\n@value base-blue: #203276;\n\n/* Feedback Color */\n@value base-green: #0EDC97;\n@value base-yellow: #FBC506;\n\n/* GreyScale */\n@value base-black: #030140;\n@value base-grey: #CCCCCC;\n@value base-dark-grey: #72757E;\n@value base-light-grey: #EFEFEF;\n@value base-white: #FFFFFF;\n\n/* Contrast extended Color */\n@value red-lighten-75: #F5795D;\n@value red-lighten-50: #F8A593;\n@value red-lighten-25: #FCD2C9;\n@value base-red-hover: #E72A00;\n@value red-darken-25: #E72A00;\n@value purple-lighten-75: #7D8FF5;\n@value purple-lighten-50: #A8B4F8;\n@value purple-lighten-25: #D4DAFC;\n@value purple-lighten-5: #EBEEFD;\n@value purple-darken-25: #404FA1;\n@value base-purple-hover: #404FA1;\n@value mint-lighten-10: #D6EFE9;\n\n/** NEW COLOR VERSION **/\n\n/* Primary Color */\n@value color-red: #DE330D;\n@value color-red-light: #F24C27;\n@value color-red-dark: #A32003;\n@value color-red-bg: #DE330D;\n\n/* Accent Color */\n@value color-purple: #4F67F3;\n@value color-purple-light: #7D8FF5;\n@value color-purple-dark: #404FA1;\n@value color-purple-bg: #F8FAFF;\n\n/* Neutral color */\n@value color-gray: #CCCCCC;\n@value color-gray-light: #EFEFEF;\n@value color-gray-dark: #72757E;\n@value color-black: #2C333E;\n\n/* Feedback color */\n@value color-success: #0EDC97;\n@value color-success-light: #D1ECF1;\n@value color-success-dark: #155724;\n@value color-warning: #FBC506;\n@value color-warning-light: #FFF3CD;\n@value color-warning-dark: #FBC506;\n@value color-error: #F24C27;\n@value color-error-light: #F8D7DA;\n@value color-error-dark: #DE330D;\n\n/* Typography */\n@value color-text: color-black;\n@value color-text-subtle: color-gray-dark;\n@value color-link: color-purple;\n@value color-link-visited: color-purple-dark;\n\n/* Border */\n@value color-border: color-gray;\n\n/* Forms */\n@value color-form-border: color-gray;\n@value color-form-focus: color-purple;\n@value color-form-error: color-error;\n@value color-form-success: color-success;\n\n/* Button */\n@value color-button-primary: color-red;\n@value color-button-primary-hover: color-red-dark;\n@value color-button-primary-focus: color-red-light;\n@value color-button-secondary: color-purple;\n@value color-button-secondary-hover: color-purple-dark;\n@value color-button-secondary-focus: color-purple-light;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base-red": `#F24C27`,
	"base-purple": `#526AF2`,
	"base-mint-green": `#ACE2D0`,
	"base-blue": `#203276`,
	"base-green": `#0EDC97`,
	"base-yellow": `#FBC506`,
	"base-black": `#030140`,
	"base-grey": `#CCCCCC`,
	"base-dark-grey": `#72757E`,
	"base-light-grey": `#EFEFEF`,
	"base-white": `#FFFFFF`,
	"red-lighten-75": `#F5795D`,
	"red-lighten-50": `#F8A593`,
	"red-lighten-25": `#FCD2C9`,
	"base-red-hover": `#E72A00`,
	"red-darken-25": `#E72A00`,
	"purple-lighten-75": `#7D8FF5`,
	"purple-lighten-50": `#A8B4F8`,
	"purple-lighten-25": `#D4DAFC`,
	"purple-lighten-5": `#EBEEFD`,
	"purple-darken-25": `#404FA1`,
	"base-purple-hover": `#404FA1`,
	"mint-lighten-10": `#D6EFE9`,
	"color-red": `#DE330D`,
	"color-red-light": `#F24C27`,
	"color-red-dark": `#A32003`,
	"color-red-bg": `#DE330D`,
	"color-purple": `#4F67F3`,
	"color-purple-light": `#7D8FF5`,
	"color-purple-dark": `#404FA1`,
	"color-purple-bg": `#F8FAFF`,
	"color-gray": `#CCCCCC`,
	"color-gray-light": `#EFEFEF`,
	"color-gray-dark": `#72757E`,
	"color-black": `#2C333E`,
	"color-success": `#0EDC97`,
	"color-success-light": `#D1ECF1`,
	"color-success-dark": `#155724`,
	"color-warning": `#FBC506`,
	"color-warning-light": `#FFF3CD`,
	"color-warning-dark": `#FBC506`,
	"color-error": `#F24C27`,
	"color-error-light": `#F8D7DA`,
	"color-error-dark": `#DE330D`,
	"color-text": `#2C333E`,
	"color-text-subtle": `#72757E`,
	"color-link": `#4F67F3`,
	"color-link-visited": `#404FA1`,
	"color-border": `#CCCCCC`,
	"color-form-border": `#CCCCCC`,
	"color-form-focus": `#4F67F3`,
	"color-form-error": `#F24C27`,
	"color-form-success": `#0EDC97`,
	"color-button-primary": `#DE330D`,
	"color-button-primary-hover": `#A32003`,
	"color-button-primary-focus": `#F24C27`,
	"color-button-secondary": `#4F67F3`,
	"color-button-secondary-hover": `#404FA1`,
	"color-button-secondary-focus": `#7D8FF5`
};
export default ___CSS_LOADER_EXPORT___;
